import { Pipe, PipeTransform } from '@angular/core';
import { OptionInterface } from '@app/interfaces/option.interface';

@Pipe({
    name: 'option',
    pure: false,
})
export class OptionPipe implements PipeTransform {
    transform(value: string, array: OptionInterface[] = []): string {
        const option = array.find((x) => x.value === value);
        return option && option.label ? option.label : '-';
    }
}
